import React from 'react';
import { motion } from 'framer-motion';
export function QuoteBand() {
  return <section className="w-full bg-sage-band py-20 md:py-28" data-id="element-117" data-mp="3u4xfub0iohmo">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-118" data-mp="3u6iae0mu00kj">
        <motion.blockquote initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="font-serif text-3xl italic leading-snug text-ink md:text-4xl" data-id="element-119" data-mp="3gelnqc3xmivj">
          “Poder con todo no es tu mejor cualidad.
          <br className="hidden md:block" data-id="element-120" data-mp="7wxwfbs1mvo4" /> Es un patrón que tiene un costo.”
        </motion.blockquote>
      </div>
    </section>;
}